import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import DriverDeliverySelect from '../../components/DriverDeliverySelect/DriverDeliverySelect';
import Button from '../../components/UI/Button/Button';

class AssignDeliveryModal extends Component {
    state = {
        deliveryId:0
    }

    componentDidMount() {
        this.props.onGetDeliveries();
      }
    deliveryChanged = (value) => {
        this.setState({deliveryId:value});   

    }

    assignDelivery = () => {
        this.props.deliveryChanged(this.state.deliveryId);        
    }

    render () {
        let driver = null;
        for (let k in this.props.drivers) {
            if (this.props.drivers[k].driverId == this.props.driverId) {
                driver = this.props.drivers[k]
            }
        }
        if (driver) {
            return (
                <div>
                <DriverDeliverySelect deliveryChanged={this.deliveryChanged} driverId={driver.driverId} />
                <Button 
                    btnType="Success"
                    clicked={this.assignDelivery}>Assign Delivery</Button>
                <Button 
                    btnType="Danger"
                    clicked={this.props.cancelAssignDelivery}>CANCEL</Button>
                    </div>
            )        
        }
        else {
            return (
                <div />
            );
        }
       
    }
}


const mapStateToProps = state => {
    return {
        drivers: state.orders.drivers,
        deliveries: state.orders.deliveries
    };
}

const mapDispatchToProps = dispatch => {
    return {
      onGetDeliveries:() => dispatch(actions.getDeliveries())
    };
  };


export default connect(mapStateToProps,mapDispatchToProps)(AssignDeliveryModal);


// WEBPACK FOOTER //
// ./src/components/AssignDeliveryModal/AssignDeliveryModal.js